import React, { useMemo } from "react";
import MediaControl from "./MediaControl";
import {
  getFeaturedMediaId,
  splitArticleCategories,
} from "../articleApi";

const getId = (item) => Number(item.id);

const BlockInspector = ({
  form,
  categories = [],
  articleId = null,
  onUpdateForm,
}) => {
  const { parents, childrenByParent } = useMemo(
    () => splitArticleCategories(categories),
    [categories]
  );
  const selectedCategoryId = form.category_id ? Number(form.category_id) : null;
  const subcategories = selectedCategoryId
    ? childrenByParent.get(selectedCategoryId) || []
    : [];
  const featuredMediaId = getFeaturedMediaId({
    featured_media_id: form.featured_media_id,
    featured_image: form.featured_image,
  });

  const selectCategory = (categoryId) => {
    const clickedId = categoryId == null ? "" : Number(categoryId);
    const nextId = Number(form.category_id) === clickedId ? "" : clickedId;
    onUpdateForm("category_id", nextId);
    const allowed = nextId
      ? (childrenByParent.get(nextId) || []).some(
          (item) => Number(item.id) === Number(form.subcategory_id)
        )
      : false;
    if (!allowed) onUpdateForm("subcategory_id", "");
  };

  const selectSubcategory = (subcategoryId) => {
    const clickedId = subcategoryId == null ? "" : Number(subcategoryId);
    const nextId = Number(form.subcategory_id) === clickedId ? "" : clickedId;
    onUpdateForm("subcategory_id", nextId);
  };

  return (
    <div className="gutenberg-inspector">
      <div className="gutenberg-inspector__section">
        <h4>Publish</h4>
        <label>
          Slug
          <input
            value={form.slug}
            placeholder="Article slug"
            onChange={(event) => onUpdateForm("slug", event.target.value)}
          />
        </label>
        <label>
          Status
          <select
            value={form.status}
            onChange={(event) => onUpdateForm("status", event.target.value)}
          >
            <option value="draft">Draft</option>
            <option value="published">Published</option>
            <option value="archived">Archived</option>
          </select>
        </label>
        <label>
          Visibility
          <select
            value={form.visibility || "public"}
            onChange={(event) => onUpdateForm("visibility", event.target.value)}
          >
            <option value="public">Public</option>
            <option value="private">Private</option>
          </select>
        </label>

        <p className="gutenberg-inspector__sublabel">Featured image</p>
        <MediaControl
          articleId={articleId}
          showFields={false}
          emptyTitle=""
          emptyHint=""
          libraryTitle="Featured image"
          libraryDescription="Select a featured image."
          value={{
            url: form.featured_image || "",
            media_id: featuredMediaId,
          }}
          onChange={(next) => {
            onUpdateForm({
              featured_media_id: next.media_id ? Number(next.media_id) : "",
              featured_image: next.preview_url || next.url || "",
            });
          }}
        />
      </div>

      <div className="gutenberg-inspector__section gutenberg-inspector__section--taxonomy">
        <h4>Categories & subcategories</h4>

        <p className="gutenberg-inspector__sublabel">Category</p>
        <div className="gutenberg-inspector__chips">
          {!parents.length && <p className="gutenberg-inspector__empty">No categories found.</p>}
          {parents.map((category) => {
            const isChecked = Number(form.category_id) === getId(category);
            return (
              <button
                key={category.id}
                type="button"
                className={`gutenberg-inspector__chip${isChecked ? " is-selected" : ""}`}
                aria-pressed={isChecked}
                onClick={() => selectCategory(category.id)}
              >
                <span>{category.name}</span>
              </button>
            );
          })}
        </div>

        {selectedCategoryId && subcategories.length > 0 && (
          <>
            <p className="gutenberg-inspector__sublabel">Subcategory</p>
            <div className="gutenberg-inspector__chips">
              {subcategories.map((subcategory) => {
                const isChecked = Number(form.subcategory_id) === getId(subcategory);
                return (
                  <button
                    key={subcategory.id}
                    type="button"
                    className={`gutenberg-inspector__chip${isChecked ? " is-selected" : ""}`}
                    aria-pressed={isChecked}
                    onClick={() => selectSubcategory(subcategory.id)}
                  >
                    <span>{subcategory.name}</span>
                  </button>
                );
              })}
            </div>
          </>
        )}
      </div>

      <div className="gutenberg-inspector__section">
        <h4>SEO</h4>
        <label>
          Meta title
          <input
            value={form.meta_title || ""}
            onChange={(event) => onUpdateForm("meta_title", event.target.value)}
          />
        </label>
        <label>
          Meta description
          <textarea
            rows={4}
            value={form.meta_description || ""}
            onChange={(event) => onUpdateForm("meta_description", event.target.value)}
          />
        </label>
        <label>
          Meta keyword
          <input
            value={form.meta_keyword || ""}
            onChange={(event) => onUpdateForm("meta_keyword", event.target.value)}
          />
        </label>
      </div>
    </div>
  );
};

export default BlockInspector;
